import { render, staticRenderFns } from "./photography.vue?vue&type=template&id=fbb868f4&scoped=true&"
import script from "./photography.vue?vue&type=script&lang=js&"
export * from "./photography.vue?vue&type=script&lang=js&"
import style0 from "./photography.vue?vue&type=style&index=0&id=fbb868f4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb868f4",
  null
  
)

export default component.exports